import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import { Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setAuthData } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash;
      const sessionId = new URLSearchParams(hash.substring(1)).get('session_id');

      if (!sessionId) {
        navigate('/login');
        return;
      }

      try {
        const response = await axios.post(`${API_URL}/api/auth/google`, {
          session_id: sessionId
        });

        const { access_token, user } = response.data;
        setAuthData(access_token, user);
        navigate('/dashboard');
      } catch (error) {
        const msg = error.response?.data?.detail || 'Errore di autenticazione';
        navigate('/login', { state: { error: msg } });
      }
    };

    processAuth();
  }, [navigate, setAuthData]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-slate-600 mx-auto mb-4" />
        <p className="text-slate-600">Accesso con Google in corso...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
